import { useTranslation } from 'react-i18next';
import { Button, styled } from 'shell/components';
import { ChatPromptActionId } from 'utils/chat/chatConstants';

const ChatPromptContinue = ({ disabled, onSubmit, prompt }) => {
    const { t } = useTranslation('common');
    const label = prompt?.label || t('controls.continue', 'Continue');

    return (
        <ContinuButton
            aria-label={label}
            disabled={disabled}
            size={'medium'}
            variant={'secondary'}
            onClick={() =>
                onSubmit({
                    messageText: 'Continue',
                    response: { selected_action_id: ChatPromptActionId.CONTINUE },
                })
            }
        >
            {label}
        </ContinuButton>
    );
};

const ContinuButton = styled(Button)(({ theme }) => ({
    width: 'fit-content',
}));

export default ChatPromptContinue;
